export function SettingsInvoice({ invoice, onChange }) {
  const update = (key, value) => onChange({ ...invoice, [key]: value });

  return (
    <div className="s-card" data-testid="invoice-info-section">
      <div className="s-card-header">
        <div className="s-card-title-row">
          <span style={{ fontSize: '16px' }}>&#129534;</span>
          <h2 className="s-card-title">Informations factures</h2>
        </div>
      </div>
      <p className="s-card-subtitle">Ces informations apparaitront sur vos factures PDF</p>
      <div className="s-form-grid">
        <div className="s-form-full">
          <label className="s-form-label">Nom du magasin *</label>
          <input className="s-input" value={invoice.store_name} onChange={(e) => update("store_name", e.target.value)} data-testid="store-name-input" />
        </div>
        <div className="s-form-full">
          <label className="s-form-label">Adresse</label>
          <input className="s-input" value={invoice.store_address} onChange={(e) => update("store_address", e.target.value)} data-testid="store-address-input" />
        </div>
        <div>
          <label className="s-form-label">Telephone</label>
          <input className="s-input" value={invoice.store_phone} onChange={(e) => update("store_phone", e.target.value)} data-testid="store-phone-input" />
        </div>
        <div>
          <label className="s-form-label">Email</label>
          <input className="s-input" type="email" value={invoice.store_email} onChange={(e) => update("store_email", e.target.value)} data-testid="store-email-input" />
        </div>
      </div>
    </div>
  );
}
